import capitalize from "lodash/capitalize";
var normalizeName = function normalizeName() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return name.replace(/[\wа-яґїіє]+/gi, function (word) {
    return capitalize(word);
  });
};
export default normalizeName;